import { NoteProperty } from "src/components";
import { TaskItemDetailDto, useEditTaskItemNote } from "src/http";

interface Props {
  taskItem: TaskItemDetailDto;
}

const TaskItemNoteProperty = (props: Props) => {
  const { mutate: editTaskItemNote, isLoading } = useEditTaskItemNote();

  function handleSaveClicked(note: string) {
    editTaskItemNote({
      taskItemGuid: props.taskItem.guid,
      note,
      teamSlug: props.taskItem.team?.slug,
      ownerUserGuids: props.taskItem.owners.map((x) => x.user.userId),
    });
  }

  return (
    <NoteProperty
      note={props.taskItem.note}
      userCanEdit={props.taskItem.userCanEdit}
      disabled={isLoading}
      onSaveClicked={handleSaveClicked}
    />
  );
};

export { TaskItemNoteProperty };
